var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('span',{staticClass:"score"},[_vm._v(_vm._s(_vm.score))]),_c('el-divider',{staticClass:"divider",attrs:{"direction":"vertical"}}),_c('span',{staticClass:"total"},[_vm._v("100")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }